import InstantCentralSearch from "./InstantCentralSearch"

export default InstantCentralSearch